export enum RoutePlanStatus {
  DRAFT = 'DRAFT',
  EXECUTED = 'EXECUTED',
}
